export default {"src":"/uk/_next/static/media/beneficiariesIcon.74808373.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};